import React, {FC, useState} from 'react'

import {observer} from 'mobx-react-lite'

import InputQuantity from 'components/elements/fields/InputQuantity'
import {IInputQuantityProps} from 'components/elements/fields/InputQuantity/InputQuantity'

interface IMobxInputQuantityProps extends IInputQuantityProps {
	name: string
	min?: number
	max?: number
	step?: number
	onQuantityChange?: (value: string) => void
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

{
	/* TODO: refactor paystubs store and quantity input to work only with numbers */
}
const MobxInputQuantity: FC<IMobxInputQuantityProps> = ({
	name,
	max,
	min = 1,
	step = 1,
	store,
	onQuantityChange,
	...props
}) => {
	const [value, setValue] = useState(store[name])

	const updateStoreValue = (value: number) => {
		store[name] = String(value)
		setValue(store[name])
		onQuantityChange && onQuantityChange(store[name])
	}

	const increment = () => {
		if (max && store[name] < max) {
			updateStoreValue(Number(store[name]) + step)
		}
	}

	const decrement = () => {
		if (store[name] > min) {
			updateStoreValue(Number(store[name]) - step)
		}
	}

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value

		setValue(value.replace(/\D/, ''))
	}

	const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		const value = Number(e.target.value)

		if (!isNaN(value)) {
			if (max && value >= max) {
				updateStoreValue(max)
			} else if (value <= min) {
				updateStoreValue(min)
			} else {
				updateStoreValue(value)
			}
		}
	}

	return (
		<InputQuantity
			value={value}
			name={name}
			increment={increment}
			decrement={decrement}
			min={min}
			max={max}
			onChange={onChange}
			onBlur={onBlur}
			{...props}
		/>
	)
}

MobxInputQuantity.displayName = 'MobxInputQuantity'

export default observer(MobxInputQuantity)
